(function () {
	'use strict';

	a3_cabin_reports.factory('CustomerEventHistoryFactory', CustomerEventHistoryFactory);
    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name CustomerEventHistoryFactory
    * @description 
    *   Add, Update, Delete and Get History Customer Events for OneStopShop
    * @ngInject
    */
	function CustomerEventHistoryFactory(GenericService) {

		var objType = 'HistoryEvents';
		var objCallback = HistoryEvent;

        /**
         * Initialize the History Event
         * @memberof CustomerEventHistoryFactory
         */
		function HistoryEvent() {
			this.GetId = GetId;
		}

		var service = {
			setHistoryEventsToStorage : setHistoryEventsToStorage,
			getHistoryEventsFromStorage : getHistoryEventsFromStorage,
			getPassengerHistory : getPassengerHistory,
			refreshPassengerHistory : refreshPassengerHistory,
			deleteOldHistoryEvents: deleteOldHistoryEvents
		};

		
		function GetId(){
			return this.FlightId;
		}

		/**
		 * Save all History Events
		 * @param {array} objList 
		 */
		function setHistoryEventsToStorage(objList) {
			GenericService.saveAll(objList,objType);
		}
		
		/**
		 * Get all History Events
		 */
		function getHistoryEventsFromStorage(){
			return GenericService.list(objType,objCallback);
		}

		/**
		 *  Get History Events of a specific passenger
		 * @param {objects} passenger 
		 */
		function getPassengerHistory(passenger){
			var passengerFqtv = passenger.Fqtv ? passenger.Fqtv.Number : null;
			var passengerUci = passenger.UCI;

			//Filter passenger by FQTV and UCI
			var passengerHistoryEvents = getHistoryEventsFromStorage().filter(p => (p.FQTVNumber && passengerFqtv && p.FQTVNumber == passengerFqtv) || p.UCI == passengerUci);

			return passengerHistoryEvents;
		}
		
		function refreshPassengerHistory(flightHistoryEvents){
			var history = getHistoryEventsFromStorage();

			flightHistoryEvents.forEach(function(event){
				var historyEvent = history.find(x => x.ToolkitItem.Id == event.ToolkitItem.Id && x.UCI == event.UCI && x.FlightNo == event.FlightNo && x.Departure == event.Departure && x.FlightDate == event.FlightDate);
				if(!historyEvent){
					GenericService.add(event, objType, objCallback);
				}
			});
		}

		 /**
         * Deletes HistoryEvents that are older than 2 days
         * @memberof DataCleanerFactory
         */
		  function deleteOldHistoryEvents(){
			var historyEvents = getHistoryEventsFromStorage();
			var fromDate = new Date();
            fromDate.setDate(fromDate.getDate() - 5);
			historyEvents = historyEvents.filter(x => x != null && x.FlightDate >= fromDate);
			setHistoryEventsToStorage(historyEvents);
        }

		return service;
	}
})();
